module.exports = __webpack_public_path__ + "99c2269a488c0aea1777ccab01e1a22f.png";